import React, { Component, Fragment } from 'react';
import DEFINE, { PATHS, DATE_TIME_FORMAT } from "../../../../constants/Define";
import * as Func from '../../../../helpers/functions';
import {
    PageListComponent, HeaderListComponent,
} from "../../common/component/Index";
import Wrapper from '../../common/component/Wrapper';
import { Tabs } from 'antd';
import RecommendationList from './RecommendationList'
import { get } from 'lodash';
import moment from 'moment';

const { TabPane } = Tabs;
let permissionActions = [];
export default class Recommandation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filters: {
                pageSize: this.props.recommendationState.pageSize,
                pageIndex: this.props.recommendationState.pageIndex,
                email: null
            },
            activeTab: 'PRODUCT'
        };
    }

    componentDidMount() {
        permissionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.RECOMMENDATION);
        this.props.getRecommendationAction({type: 2});
    }
    
    render() {
        const { t, recommendationState } = this.props;
        const { data, isFetching, totalCount, totalPage, pageIndex, pageSize } = recommendationState;
        const pagination = { totalCount, totalPage, defaultCurrent: pageIndex, pageSize };
        const lastSync = get(data, 'recommendation[0].lastSync')
        const { activeTab } = this.state;
        return (
            <Fragment>
                <PageListComponent>
                    <HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'suppliers'}
                        titleHeader={t('navigation.recommendation')}
                    />
                    <div className="title-content">Danh sách điểm số User / tag toàn hệ thống</div>
                    <Tabs defaultActiveKey={ activeTab } onChange={ this.onChangeTab } activeKey={ activeTab } animated={ false }>
                        {/* {
                            permissionActions.allowView &&
                            <TabPane tab={ t('item.recommendation.tagTab') } key="USER">
                               <RecommendationList 
                                    data={data?.recommendation || []}
                                    isFetching = {isFetching}
                                    pagination={pagination}
                                    onChange={this.onTableChange}
                                    activeTab={activeTab}
                                />
                            </TabPane>
                        } */}
                        {
                            permissionActions.allowView &&
                            <TabPane tab={ t('item.recommendation.prodTab') } key="PRODUCT">
                                {lastSync && <div className="text-right"><b>Last sync at:</b> {moment(moment.utc(lastSync).toDate()).format(DATE_TIME_FORMAT.DATE_TIME)}</div>}
                                <RecommendationList 
                                    data={data?.recommendation || []}
                                    isFetching = {isFetching}
                                    pagination={pagination}
                                    onChange={this.onTableChange}
                                    activeTab={activeTab}
                                />
                            </TabPane>
                        }
                    </Tabs>
                    
                </PageListComponent>
            </Fragment>
        );
    }

    onChangeTab = (keyActive)=>{
        let typeTmp = 1;
        if(keyActive === 'PRODUCT'){
            typeTmp = 2;
        }
        this.props.getRecommendationAction({
            pageSize: this.props.recommendationState.pageSize,
            pageIndex: 1,
            email: null, 
            type: typeTmp
        });
        this.setState({activeTab: keyActive})
    }

    onTableChange = (pagination, filters, sorter) => {
        let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
        this.setState({
            filter: newFilters
        });
        let typeTmp = 1;
        if(this.state.activeTab === 'PRODUCT'){
            typeTmp = 2;
        }
        this.props.getRecommendationAction({ ...newFilters, type: typeTmp});
    };

}
